import lazyLoad from 'app/shared-components/util/lazyLoad';

const TeamsApp = lazyLoad(() => import('./TeamsApp'));
const TeamApp = lazyLoad(() => import('./team/TeamApp'));
const ChannelAppClientMembers = lazyLoad(() => import('app/shared-components/channel/channelApp/ChannelAppClientMembers'));
const ChannelAppClient = lazyLoad(() => import('app/shared-components/channel/channelApp/ChannelAppClient'));
const ChannelAppClients = lazyLoad(() => import('app/shared-components/channel/channelApp/ChannelAppClients'));
const ChannelFiles = lazyLoad(() => import('app/shared-components/channel/channelApp/ChannelFiles'));
const ChannelAdmin = lazyLoad(() => import('app/shared-components/channel/channelApp/ChannelAdmin'));
const ChannelMembers = lazyLoad(() => import('app/shared-components/channel/channelApp/ChannelMembers'));
const ChannelAppTopicMembers = lazyLoad(() => import('app/shared-components/channel/channelApp/ChannelAppTopicMembers'));
const TeamForm = lazyLoad(() => import('./team/TeamForm'));
const ChannelAppChannel = lazyLoad(() => import('app/shared-components/channel/channelApp/ChannelAppChannel'));
const ChannelAppThreads = lazyLoad(() => import('app/shared-components/channel/channelApp/ChannelAppThreads'));
const TopicList = lazyLoad(() => import('app/shared-components/channel/TopicList'));


const TeamsAppConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  helpConfig: {
    query: 'teams',
    tag: 'teams',
    title: 'Teams'
  },
  routes: [
    {
      path: 'apps/teams',
      element: <TeamsApp />,
      children: [
        {
          path: ':id',
          element: <TeamForm />,
        },
        {
          path: 'invites',
          element: <div/>,
          helpConfig: {
            query: 'team invites',
            tag: 'teams',
            title: 'Team Invites'
          }
        }
      ],
    },
    {
      path: 'apps/team/:groupId',
      element: <TeamApp />,
      helpConfig: {
        query: 'team collaboration',
        title: 'Team Collaboration'
      },
      children: [
		{
          path: '',
          element: <ChannelAppChannel type="team" />,
        },
        {
          path: 'searchresults',
          element: <ChannelAppChannel type="team" />,
        },
        {
          path: 'channel/:channelId',
          element: <ChannelAppChannel type="team" />,
        },
        {
          path: 'channel/:channelId/searchresults',
          element: <ChannelAppChannel type="team" />,
        },
        {
          path: 'channel/:channelId/members',
          element: <ChannelAppTopicMembers type="team" />,
          helpConfig: {
            query: 'team members',
            tag: 'teams',
            title: 'Team Members'
          },
        },
        {
          path: 'threads',
          element: <ChannelAppThreads type="team"/>,
        },
        {
          path: 'topics',
          element: <TopicList type="team"/>,
          helpConfig: {
            query: 'team topics',
            tag: 'teams',
            title: 'Team Topics'
          },
        },
        {
          path: 'topic/:topicId',
          element: <TopicList type="team"/>,
          helpConfig: {
            query: 'team topics',
            tag: 'teams',
            title: 'Team Topics'
          },
        },
        {
          path: 'admin',
          element: <ChannelAdmin type="team" formElement={TeamForm} />,
          helpConfig: {
            query: 'team administration',
            tag: 'teams',
            title: 'Team Administration'
          },
        },
        {
          path: 'members',
          element: <ChannelMembers type="team" />,
          helpConfig: {
            query: 'team members',
            tag: 'teams',
            title: 'Team Members'
          },
        },
        {
          path: 'member/:memberId',
          element: <ChannelMembers type="team" />,
        },
        {
          path: 'result/:userId',
          element: <ChannelMembers type="team" />,
        },
        {
          path: 'files',
          element: <ChannelFiles type="team" />,
        },
        {
          path: 'files/view/:fileId',
          element: <ChannelFiles type="team" />,
        },
        {
          path: 'files/:folderId',
          element: <ChannelFiles type="team" />,
        },
        {
          path: 'files/:folderId/view/:fileId',
          element: <ChannelFiles type="team" />,
        },
        {
          path: 'clients',
          element: <ChannelAppClients type="team" />,
          helpConfig: {
            query: 'team client collaboration',
            title: 'Team Clients'
          },
        },
        {
          path: 'client/:clientId',
          element: <ChannelAppClient type="team" />,
          helpConfig: {
            query: 'team client collaboration',
            title: 'Team Clients'
          },
        },
        {
          path: 'client/:clientId/searchresults',
          element: <ChannelAppClient type="team" />,
          helpConfig: {
            query: 'team client collaboration',
            title: 'Team Clients'
          },
        },
        {
          path: 'client/:clientId/members',
          element: <ChannelAppClientMembers type="team" />,
          helpConfig: {
            query: 'team client collaboration',
            title: 'Team Clients'
          },
        },
      ],
    },
  ],
};

export default TeamsAppConfig;
